import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a83ed804"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-dialog modal-dialog-centered mw-650px mh-300px" }
const _hoisted_2 = {
  class: "modal-content bgi-no-repeat gutter-b card-stretch",
  style: {"background-color":"#1b283f","background-position":"right bottom","background-size":"50% auto","background-image":"url(/media/svg/patterns/taieri.svg)"}
}
const _hoisted_3 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex justify-content-center mb-5 text-white font-weight-bolder fs-1\" data-v-a83ed804><h1 class=\"fs-30 text-white\" data-v-a83ed804>Trial Expirado!</h1></div><div class=\"d-flex justify-content-left mb-10\" data-v-a83ed804><div class=\"text-white fw-bold fs-5\" data-v-a83ed804>Seu período de degustação acabou. 🥲</div></div><div class=\"d-flex justify-content-left mb-10\" data-v-a83ed804><div class=\"text-white fw-bold fs-5 text-left\" data-v-a83ed804>Mas não preocupe sua instalação ainda está funcionando!</div></div><div class=\"d-flex justify-content-left mb-10\" data-v-a83ed804><div class=\"text-white fw-bold fs-5 text-left\" data-v-a83ed804>Selecione o plano que melhor se adequa ao seu negócio. </div></div>", 4)
const _hoisted_8 = { class: "d-flex justify-content-center mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "modal",
    id: "kt_modal_trial_expired",
    ref: "trialExpiredModalRef",
    tabindex: "-1",
    "aria-hidden": "true",
    onHide: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.hideTrialExpiredModal && _ctx.hideTrialExpiredModal(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", {
              class: "btn btn-primary",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToPlans && _ctx.goToPlans(...args))),
              "data-bs-dismiss": "modal"
            }, "ESCOLHER PLANO")
          ])
        ])
      ])
    ])
  ], 544))
}